export default function isMacintosh() {
  const system = navigator.userAgent.toLowerCase()
  return system.includes("macintosh")
}
